import { render, staticRenderFns } from "./swiper-btn-wrap-quarternary.vue?vue&type=template&id=6ec94f32&scoped=true&"
import script from "./swiper-btn-wrap-quarternary.vue?vue&type=script&lang=js&"
export * from "./swiper-btn-wrap-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec94f32",
  null
  
)

export default component.exports